import './skills.css';

const skills = [
  'React',
  'TailwindCSS',
  'Svelte',
  'NodeJS',
  'Python',
  'TypeScript',
  'Twilio',
  'AI Integrations',
  'CI/CD',
];

export default function Skills() {
  return (
    <div className="skillswrapper" id="skills">
      <div className="skillsHeader" data-aos="fade-down">
        <h1>skills</h1>
      </div>

      {skills.map((skill, index) => {
        const animation = index % 2 === 0 ? 'fade-left' : 'fade-right';

        return (
          <div
            key={skill}
            data-aos={animation}
            className="skillwrapper"
          >
            <div className="imgwrapper">
              {index % 2 === 0 ? (
                <>
                  <h3>{skill}</h3>
                </>
              ) : (
                <>
                  <h3>{skill}</h3>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
